import { Res } from '../api';

const CASH_CONTROL = 'CashControl';
const CASHLOGY = 'cashlogy';
const CASHKEEPER = 'cashkeeper';
const CASHGUARD = 'cashguard';
const CASHDRO = 'cashdro';
const CASHINFINITY = 'cashinfinity';
const CCTV = 'CCTV';
const INTEGRATION_SERVICES = 'IntegrationServices';
const DEMO = 'DEMO';
const POS = 'POS';
const SMARTPHONE = 'SmartphoneOrders';
const SALE_FORMATS = 'SaleFormats';
const KITCHEN_DISPLAYS = 'KitchenDisplays';
const PURCHASES_AND_STOCK = 'PurchasesAndStock';
const MY_AGORA = 'MyAgora';
const HUB = 'Hub';
const HUB_CLIENT = 'HubClient';
const HUB_CLIENT_BUNDLE = 'HubClientBundle';
const PRICELIST_SCHEDULER = 'PriceListScheduler';
const EMAILING = 'Emailing';
const ONLINE_RESERVATON = 'OnlineReservations';
const CARD_PROCESSOR = 'CardProcessor';
const POS_LITE = 'POSLite';
const ATTENDANCE = 'Attendance';
const GSTOCK = 'GStock';
const COVER_MANAGER = 'CoverManager';
const SMART_MENU = 'SmartMenu';
const TRACEABILITY = 'Traceability';
const TICKET_BAI = 'TicketBAI';
const WEBPOS = 'WebPos';
const SYSTEM_UPGRADE = 'SystemUpgrade';
const SYSTEM_UPGRADE_LITE = 'SystemUpgradeLite';
const DELIVERY = 'Delivery';
const DEVICES = 'Devices';
const SCALE_SYSTEM = 'ScaleSystem';
const SIZE_AND_COLOR = 'SizingAndColors';

const UNKNOWN = 'Unknown';


export function getDescription(moduleName: string): string {
	switch (moduleName) {
		case CASH_CONTROL:
			return Res.Const.ENUM_MODULE_NAMES_CASH_CONTROL();
		case SMART_MENU:
			return Res.Const.ENUM_MODULE_NAMES_SMART_MENU();
		case CCTV:
			return Res.Const.ENUM_MODULE_NAMES_CCTV();
		case INTEGRATION_SERVICES:
			return Res.Const.ENUM_MODULE_NAMES_INTEGRATION_SERVICES();
		case DEMO:
			return Res.Const.ENUM_MODULE_NAMES_DEMO();
		case POS:
			return Res.Const.ENUM_MODULE_NAMES_POS();
		case SMARTPHONE:
			return Res.Const.ENUM_MODULE_SMARTPHONE();
		case SALE_FORMATS:
			return Res.Const.ENUM_MODULE_SALE_FORMATS();
		case KITCHEN_DISPLAYS:
			return Res.Const.ENUM_MODULE_KITCHEN_DISPLAYS();
		case PURCHASES_AND_STOCK:
			return Res.Const.ENUM_MODULE_NAMES_PURCHASES_AND_STOCK();
		case MY_AGORA:
			return Res.Const.ENUM_MODULE_NAMES_MY_AGORA();
		case HUB:
			return Res.Const.ENUM_MODULE_NAMES_HUB();
		case HUB_CLIENT:
			return Res.Const.ENUM_MODULE_NAMES_HUB_CLIENT();
		case HUB_CLIENT_BUNDLE:
			return Res.Const.ENUM_MODULE_NAMES_HUB_CLIENT_BUNDLE();
		case PRICELIST_SCHEDULER:
			return Res.Const.ENUM_MODULE_NAMES_PRICELIST_SCHEDULER();
		case EMAILING:
			return Res.Const.ENUM_MODULE_NAMES_EMAILING();
		case ONLINE_RESERVATON:
			return Res.Const.ENUM_MODULE_NAMES_ONLINE_RESERVATIONS();
		case CARD_PROCESSOR:
			return Res.Const.ENUM_MODULE_NAMES_CARD_PROCESSOR();
		case POS_LITE:
			return Res.Const.ENUM_MODULE_NAMES_POS_LITE();
		case ATTENDANCE:
			return Res.Const.ENUM_MODULE_NAMES_ATTENDANCE();
		case CASHLOGY:
			return Res.Const.ENUM_MODULE_NAMES_CASHLOGY();
		case CASHKEEPER:
			return Res.Const.ENUM_MODULE_NAMES_CASHKEEPER();
		case CASHGUARD:
			return Res.Const.ENUM_MODULE_NAMES_CASHGUARD();
		case CASHDRO:
			return Res.Const.ENUM_MODULE_NAMES_CASHDRO();
		case CASHINFINITY:
			return Res.Const.ENUM_MODULE_NAMES_CASHINFINITY();
		case COVER_MANAGER:
			return Res.Const.ENUM_MODULE_NAMES_COVER_MANAGER();
		case GSTOCK:
			return Res.Const.ENUM_MODULE_NAMES_GSTOCK();
		case TRACEABILITY:
			return Res.Const.ENUM_MODULE_NAMES_TRACEABILITY();
		case TICKET_BAI:
			return Res.Const.ENUM_MODULE_NAMES_TICKET_BAI();
		case WEBPOS:
			return Res.Const.ENUM_MODULE_NAMES_WEBPOS();
		case SYSTEM_UPGRADE:
			return Res.Const.ENUM_MODULE_NAMES_SYSTEM_UPGRADE();
		case SYSTEM_UPGRADE_LITE:
			return Res.Const.ENUM_MODULE_NAMES_SYSTEM_UPGRADE_LITE();
		case DELIVERY:
			return Res.Const.ENUM_MODULE_NAMES_DELIVERY();
		case DEVICES:
			return Res.Const.ENUM_MODULE_NAMES_DEVICES();
		case SCALE_SYSTEM:
			return Res.Const.ENUM_MODULE_NAMES_SCALE_SYSTEM();
		case SIZE_AND_COLOR:
			return Res.Const.ENUM_MODULE_NAMES_SIZE_AND_COLOR();
		case UNKNOWN:
			return Res.Const.ENUM_MODULE_UNKNOWN();
		default:
			return moduleName;
	}
}
